.Wrapper
    display: flex
    flex-direction: column
    align-items: flex-start
    padding: 0
    font-size: 14px
    & .ListItem + .ListItem
        border-top: 1px solid rgb($globalSettingsStrokeTertiary)
        &.ListItemConfig
            border-top: 1px solid rgb(215, 215, 220)
    .ListItem
        display: flex
        width: 100%
        gap: 10px
        justify-content: space-between
        align-items: center
        box-sizing: border-box
        cursor: pointer
        stroke: rgb($globalSettingsFontSecondary)
        &:hover
            background-color: rgb($globalSettingsBackgroundSecondary)
            stroke: rgb($globalSettingsFontPrimary)
        .LabelContainerSimple
            width: 100%
            justify-content: center
        .LabelContainer
            min-width: 0
            display: flex
            flex-grow: 1
            flex-shrink: 1
            position: relative
            cursor: pointer
            font-size: 14px
            gap: 10px
            -webkit-user-select: none
            -moz-user-select: none
            -ms-user-select: none
            user-select: none
            align-items: center
            & input
                position: absolute
                opacity: 0
                cursor: pointer
                &:checked~.LabelSVG
                    .LabelSvgBg
                        fill: rgb($globalCalendarSelectionBackgroundPrimary)
                    .LabelSvgTic
                        stroke: rgb($globalCalendarSelectionFont)
                &:checked~.SelectRadioLabel .ListItemRow
                    font-weight: 700
            .LabelSVG
                flex-shrink: 0
            .SelectRadioLabel
                min-width: 0
                display: flex
                flex-grow: 1
                flex-direction: column
                justify-content: center
                gap: 5px
                .ListItemRow
                    max-width: 100%
                    display: -webkit-box
                    -webkit-line-clamp: 2
                    -webkit-box-orient: vertical
                    text-align: left
                    text-overflow: ellipsis
                    overflow: hidden
                    padding: 2px 5px
        .ListItemPrice
            min-width: 0
            white-space: nowrap
            overflow: hidden
            //text-overflow: ellipsis
            min-width: 0
            flex-shrink: 0
        .ListItemPriceVariations
            font-weight: 700
    .ListItemDefault
        height: 40px
        padding: 0 13px
    .ListItemConfig
        font-family: 'Nunito'
        height: 40px
        padding: 0 15px
        border-top: 1px solid rgb(215, 215, 220)
        background-color: rgb(255,255,255)
        stroke: rgb($globalSettingsFontSecondary)
        fill: rgb($globalSettingsFontSecondary)
        &:hover
            background-color: rgb(245,245,245)
            stroke: rgb($globalSettingsFontSecondary)
            fill: rgb($globalSettingsFontSecondary)
    .ListItemSimple
        padding: 2px
        text-align: center
    .ListItemSearch
        padding: 15px 10px
        color: rgb($globalSettingsFontPrimary)
    .ListItemVariations
        padding: 15px
        color: rgb($globalSettingsFontPrimary)
    .DisabledItem
        color: rgb($globalSettingsStrokePrimary)
        stroke: rgb($globalSettingsStrokePrimary)
        fill: rgb($globalSettingsStrokePrimary)
        cursor: default !important
    .ConfirmButton
        width: 100%
        padding: 5px
        position: sticky
        bottom: 0

.NoStroke
    stroke: none !important

\rentware-checkbox
    margin-right: 9px
